import { render, staticRenderFns } from "./TableSelector.vue?vue&type=template&id=1e630454&scoped=true&"
import script from "./TableSelector.vue?vue&type=script&lang=js&"
export * from "./TableSelector.vue?vue&type=script&lang=js&"
import style0 from "./TableSelector.vue?vue&type=style&index=0&id=1e630454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e630454",
  null
  
)

export default component.exports